<template>
  <ContainerBox>
    <template v-slot:header>
      <div class="base-header">
        <div class="content">
          <img class="level" :src="dataSource.level.value" alt="" />
          <span class="name">{{ dataSource.name.value }}</span>
          <span class="cv-name"> CV：{{ dataSource.cv.value }} </span>
        </div>
      </div>
    </template>
    <div class="base-info">
      <div class="line-1">
        <div class="info-item">
          <div class="label">阶段</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.jd.icon.hasValue && dataSource.jd.icon.value"
              :src="dataSource.jd.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.jd.text.value }}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="label">属性</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.sx.icon.hasValue && dataSource.sx.icon.value"
              :src="dataSource.sx.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.sx.text.value }}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="label">职业</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.zy.icon.hasValue && dataSource.zy.icon.value"
              :src="dataSource.zy.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.zy.text.value }}</span>
          </div>
        </div>
      </div>
      <div class="line-1">
        <div class="info-item">
          <div class="label">企业</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.qy.icon.hasValue && dataSource.qy.icon.value"
              :src="dataSource.qy.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.qy.text.value }}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="label">部队</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.bd.icon.hasValue && dataSource.bd.icon.value"
              :src="dataSource.bd.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.bd.text.value }}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="label">实装日期</div>
          <div class="value">
            <img
              class="icon-value"
              v-if="dataSource.szrq.icon.hasValue && dataSource.szrq.icon.value"
              :src="dataSource.szrq.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.szrq.text.value }}</span>
          </div>
        </div>
      </div>
      <div class="line-2">
        <div class="info-item">
          <div class="label">武器</div>
          <div class="value" style="flex-direction: column; align-items: center;gap:4px;">
            <img
              class="icon-value"
              v-if="dataSource.wq.icon.hasValue && dataSource.wq.icon.value"
              :src="dataSource.wq.icon.value"
              alt=""
            />
            <span class="text-value">{{ dataSource.wq.text.value }}</span>
          </div>
        </div>
        <div class="info-item" style="width: 380px;">
          <div class="label">介绍</div>
          <div class="value description">
            <span class="text-value">{{ dataSource.js.text.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </ContainerBox>
</template>

<script>
import ContainerBox from "./containerBox.vue";

export default {
  name: "BaseInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { ContainerBox },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.base-header {
  width: 100%;
  padding: 10px 0;
  .content {
    position: relative;
    display: flex;
    align-items: center;
    padding: 6px;
    width: 100%;
    height: 52px;
    background: url("~@/assets/nikke_imgs/base-header-bg.png") no-repeat;
    background-size: 100% 100%;
    .level {
      min-width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .name {
      font-weight: 900;
      font-size: 24px;
      color: #f2f4f1;
      line-height: 28px;
    }
    .cv-name {
      position: absolute;
      right: 10px;
      top: 10px;
      font-weight: bold;
      font-size: 14px;
      color: #f2f4f1;
      line-height: 16px;
    }
  }
}

.base-info {
  padding-bottom: 15px;
  .line-1 {
    width: 100%;
    height: 36px;
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
  }
  .line-2 {
    width: 100%;
    height: 56px;
    display: flex;
    gap: 20px;
  }
  .info-item {
    width: 180px;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .label {
      flex-shrink: 0;
      width: 64px;
      height: 100%;
      background: #45474a;
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      color: #f2f4f1;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .value {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      gap: 9px;
      width: 100%;
      .icon-value {
        min-width: 20px;
        height: 24px;
      }
      .text-value {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
      }
    }
    .description {
      padding: 4px 10px;
      align-self: stretch;
      overflow: auto;
      display: block;
    }
  }
}
</style>
